<template>
  <div style="background-color: white; min-height: 100vh; overflow-y: auto">
    <div class="vg-content">
      <van-image class="logo" width="100" height="50" :src="srcLogo"/>
      <div class="entry" style="margin-top: 45px;">
        <span class="title">手机号</span>
        <van-field class="text" v-model="userPhone" type="tel" placeholder="请输入手机号" :maxlength="11" :border="false"
                   center/>
      </div>
      <div class="entry">
        <span class="title">验证码</span>
        <div class="content">
          <van-field class="code" v-model="verifyCode" type="digit" placeholder="请输入验证码" :maxlength="4"
                     :border="false" center/>
          <div class="get-code" :class="{disabled: isGetCode}" @click="getCode">{{ strGetCode }}</div>
        </div>
      </div>
      <div class="title" style="margin-top: 20px; margin-left: 25px">{{ hint }}</div>
    </div>
    <vg-button-group>
      <vg-button type="primary" @click="onSubmit">{{ btnStr }}</vg-button>
    </vg-button-group>
  </div>
</template>

<script>
import {Field, Image as VanImage, Toast} from "vant";
import VgButton from "@/components/Commons/VgButton";
import VgButtonGroup from "@/components/Commons/VgButtonGroupFixed.vue";
import srcLogo from "@/assets/login/kaidelogo.png";
import validate from "@/filters/validate";
import {client} from "@/libraries/http";
import useAuthnStore from "@/store/authn";

export default {
  name: "ChargePhone",
  components: {
    VanImage, "van-field": Field, VgButton, VgButtonGroup,
  },
  data() {
    return {
      srcLogo: srcLogo,
      userPhone: "",
      verifyCode: "",
      isGetCode: false,
      strGetCode: "获取验证码",
      id: "",
      isInvoice: false,
      hint: "注：手机号用于缴费后开取电子发票",
      btnStr: "去支付",
    }
  },
  created() {
    console.log(this.$route);
    this.id = this.$route.query.id;
    this.isInvoice = this.$route.query.isInvoice;
    this.hint = this.isInvoice ? "注：输入支付用的手机号码" : "注：手机号用于缴费后开取电子发票";
    this.btnStr = this.isInvoice ? "开具发票" : "去支付";
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    getCode() {
      if (this.isGetCode) {
        return;
      }
      if (!this.checkInput(false)) {
        return;
      }
      let params = {
        account: this.userPhone,
        bizType: this.isInvoice ? "INVOICE_LONGIN" : "INVOICE",
      };
      client.post("/api/public/verifycode", params).then(() => {
        Toast.success('发送成功');
        this.isGetCode = true;
        this.strGetCode = "60秒倒计时";
        this.count = 60;
        this.timer = setInterval(() => this.countDown(), 1000);
      })
    },
    onSubmit() {
      if (!this.checkInput(true)) {
        return;
      }
      this.isInvoice ? this.toInvoice() : this.toPay();
    },
    countDown() {
      this.count--;
      if (this.count > 0) {
        this.strGetCode = this.count + "秒倒计时";
      } else {
        clearInterval(this.timer);
        this.isGetCode = false;
        this.strGetCode = "获取验证码";
      }
    },
    checkInput(isSubmit) {
      if (!this.userPhone) {
        Toast("请输入手机号");
        return false;
      }
      if (!validate.isPhone(this.userPhone)) {
        Toast("手机号格式不正确，请重新输入");
        return false;
      }
      if (isSubmit && !this.verifyCode) {
        Toast("请输入验证码");
        return false;
      }
      return true;
    },
    toPay() {
      let params = {
        id: this.id,
        phoneNumber: this.userPhone,
        code: this.verifyCode,
        bizType: "INVOICE"
      };
      client.post("/api/public/login/external", params).then(res => {
        console.log(res);
        const authn = useAuthnStore();
        authn.token({
          token: res.data.token,
          user: {
            loginType: res.data.loginType,
            userName: res.data.userName,
            userPhone: res.data.userPhone
          }
        });
        return client.get('/api/h5/external/sporadic-billing-record/state?id=' + this.id)
      }).then(res => {
        console.log(res);
        if (res.data.paymentStatus === "PAIED") {
          this.$router.replace({path: '/scanVerify/chargeState', query: {state: "FAILED"}});
        } else {
          client.post('/api/h5/external/sporadic-billing-record/pay', params).then(res => {
            console.log(res);
            this.$router.replace({
              path: '/scanVerify/chargePay', query: {
                orderNo: res.data.orderNo,
                orderAmount: res.data.orderAmount
              }
            });
          });
        }
      });
    },
    toInvoice() {
      // this.$toast("该功能尚未开放，敬请期待。")
      let params = {
        phoneNumber: this.userPhone,
        code: this.verifyCode,
        bizType: "INVOICE_LONGIN"
      };
      client.post("/api/public/login/external", params).then(res => {
        console.log(res);
        const authn = useAuthnStore();
        authn.token({
          token: res.data.token,
          user: {
            loginType: res.data.loginType,
            userName: res.data.userName,
            userPhone: res.data.userPhone
          }
        });
        return client.post('/api/h5/invoice/verify', params)
      }).then(res => {
        console.log(res);
        this.$router.replace({path: '/scanVerify/chargeInvoice', query: {phoneNum: this.userPhone}});
      });
    },
    getPayState() {
      client.get('/api/h5/external/sporadic-billing-record/state?id=' + this.id
      ).then(res => {
        console.log(res);
        if (res.data.paymentStatus === "PAIED") {
          this.$router.replace({path: '/scanVerify/chargeState', query: {state: "FAILED"}});
        }
      });
    },
  },
}
</script>

<style scoped>
.vg-content {
  margin: 15px;
  display: flex;
  flex-direction: column;
  min-height: 100%;
  align-items: stretch;
}

.logo {
  align-self: flex-start;
}

.entry {
  margin: 15px 25px 0px;
  display: flex;
  flex-direction: column;

}

.title {
  margin-top: 15px;
  color: #101010;
  font-size: 14px;
}

.text {
  margin-top: 5px;
  padding-left: 0px;
  padding-right: 0px;
  height: 40px;
  color: #101010;
  font-size: 16px;
  border-bottom: 1px solid #E5E5EA;
}

.content {
  margin-top: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #E5E5EA;
}

.code {
  padding-left: 0px;
  padding-right: 0px;
  height: 40px;
  color: #101010;
  font-size: 16px;
}

.get-code {
  margin-left: 15px;
  color: #4BA9F6;
  font-size: 14px;
  flex-shrink: 0;
}

.disabled {
  color: #B4B4B4;
}

::v-deep .van-field__control::placeholder {
  color: #B4B4B4 !important;
}

::v-deep .van-field__control::-webkit-input-placeholder { /* 使用webkit内核的浏览器 */
  color: #B4B4B4 !important;
}

::v-deep .van-field__control:-moz-placeholder { /* Firefox版本4-18 */
  color: #B4B4B4 !important;
}

::v-deep .van-field__control::-moz-placeholder { /* Firefox版本19+ */
  color: #B4B4B4 !important;
}

::v-deep .van-field__control:-ms-input-placeholder { /* IE浏览器 */
  color: #B4B4B4 !important;
}

</style>
